import { render } from "./RecommendFoodView.vue?vue&type=template&id=90daae9a&scoped=true&ts=true"
import script from "./RecommendFoodView.vue?vue&type=script&lang=ts"
export * from "./RecommendFoodView.vue?vue&type=script&lang=ts"

import "./RecommendFoodView.vue?vue&type=style&index=0&id=90daae9a&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90daae9a"]])

export default __exports__